var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { get } from "lodash";
import WalletActions from "@irati/wallet/store/actions/Wallet";
import history from "@irati/utils/history";
import Loading from "@irati/ui/src/Loading";
import { hangPromise } from "@irati/utils/promise";
import loginService from "@irati/auth/services/login";
var Logout = /** @class */ (function (_super) {
    __extends(Logout, _super);
    function Logout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise()
        };
        return _this;
    }
    Logout.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, clearWallet = _a.clearWallet, location = _a.location;
        clearWallet();
        var load = loginService.logout().then(function () {
            history.replace({
                pathname: "/welcome/login",
                state: get(location, "state", {})
            }, _this.context.apps.PLATFORM);
        });
        this.setState({ load: load });
    };
    Logout.prototype.render = function () {
        return React.createElement(Loading, { load: this.state.load });
    };
    Logout.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return Logout;
}(Component));
export { Logout };
var actions = function (dispatch) {
    return {
        clearWallet: function () { return dispatch(WalletActions.clear()); }
    };
};
export default connect(null, actions)(Logout);
